import { render, staticRenderFns } from "./ViolationReport.vue?vue&type=template&id=51e9a3da&scoped=true"
import script from "./ViolationReport.vue?vue&type=script&lang=js"
export * from "./ViolationReport.vue?vue&type=script&lang=js"
import style0 from "./ViolationReport.vue?vue&type=style&index=0&id=51e9a3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e9a3da",
  null
  
)

export default component.exports